import React, { useCallback, useMemo, useState, useEffect } from 'react';
import Highcharts, { Options } from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import classNames from 'classnames';
import { getOverviewOfSentConnections, formatDate } from 'providers'
import { useAppSelector } from 'store/hooks';

// const options = {
//   title: {
//     text: 'Connection Requests',
//   },
//   series: [{
//     data: [1, 2, 3],
//     name: 'Total',
//   },
//   {
//     data: [2, 5, 3],
//     name: 'Bi Wu',
//   }]
// }

interface Props {
  className?: string;
}

export const SentOverviewChart: React.FC<Props> = ({ className }) => {
  const allSenders = useAppSelector(state => state.accounts.fulllist);
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [loading, setLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<Options>({
    title: {
      text: 'Connection Requests'
    },
    yAxis: {
      title: {
        text: 'Number of Connections'
      }
    }
  });
  const senders = useMemo(() => allSenders.map(item => item.user_name), [allSenders]);

  const updateChart = useCallback((dtFrom: Date, dtTo: Date) => {
    setLoading(true);
    getOverviewOfSentConnections({
      startDate: formatDate(dtFrom!),
      endDate: formatDate(dtTo!),
      senders: senders,
    })
      .then(_options => setOptions({ ...options, ..._options }))
      .finally(() => setLoading(false));
  }, [options, senders, setOptions, setLoading]);

  useEffect(() => {
    const now = new Date();
    const startDt = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
    setStartDate(startDt);
    updateChart(startDt, now);
    // tslint:disable-next-line
  }, [senders]);

  return (
    <div className={classNames(className, 'border border-gray border-solid rounded-md px-4 py-8')}>
      <div className="flex justify-end mb-4">
        <DesktopDatePicker
          label="From"
          inputFormat="MM/dd/yyyy"
          value={startDate}
          onChange={val => setStartDate(val!)}
          renderInput={(params) => <TextField {...params} />}
          showDaysOutsideCurrentMonth={true}
        />
        <DesktopDatePicker
          className="ml-4"
          label="To"
          inputFormat="MM/dd/yyyy"
          value={endDate}
          onChange={val => setEndDate(val!)}
          renderInput={(params) => <TextField {...params} />}
          showDaysOutsideCurrentMonth={true}
        />
        <Button
          className="ml-4"
          variant="contained"
          disabled={loading}
          onClick={() => updateChart(startDate, endDate)}
        >
          Submit
        </Button>
      </div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
  )
}

export default SentOverviewChart;